import { Breadcrumbs as MaterialBreadcrumbs } from '@mui/material'
import { Link } from 'react-router-dom'
import { ClientRoute } from 'routes/client'
import styled from 'styled-components'

interface BreadcrumbProps {
  route: string
  homePath?: string
  homeLabel?: string
  excludePaths?: string[]
  linkComponent?: React.ComponentType<any>
}

export default function Breadcrumbs({
  route,
  homePath = ClientRoute.COURSE_EDITOR_FRONT_PAGE,
  homeLabel = 'Home',
  excludePaths = [],
  linkComponent: LinkComponent = BreadcrumbLink,
}: BreadcrumbProps) {
  const routeParts = route
    .split('/')
    .filter(Boolean)
    .filter((part) => !part.startsWith(':'))

  if (routeParts.length > 1 && excludePaths.includes(routeParts[routeParts.length - 1])) {
    routeParts.pop()
  }

  return (
    <MaterialBreadcrumbs aria-label="breadcrumb">
      {routeParts.map((part, index) => {
        const path = `/${routeParts.slice(0, index + 1).join('/')}`
        const isLastPart = index === routeParts.length - 1
        return (
          <LinkComponent key={path} to={index === 0 ? homePath : path} isLast={isLastPart}>
            {index === 0 ? homeLabel : part}
          </LinkComponent>
        )
      })}
    </MaterialBreadcrumbs>
  )
}

const BreadcrumbLink = styled(Link)<{ isLast?: boolean }>`
  color: ${(props) => (props.isLast ? props.theme.customPalette.iconGray : '#8a8a8a')};
  text-decoration: none;
  font-size: 14px;
  line-height: 20px;
  text-transform: capitalize;
`
